// This is the enum for the workflow handler IDs
// It is a part of ui and not a domain level enum.
export enum WorkflowHandlerID {
  TARGET_TOP = 'target-top',
  TARGET_RIGHT = 'target-right',
  TARGET_BOTTOM = 'target-bottom',
  TARGET_LEFT = 'target-left',
  SOURCE_TOP = 'source-top',
  SOURCE_RIGHT = 'source-right',
  SOURCE_BOTTOM = 'source-bottom',
  SOURCE_LEFT = 'source-left',
  SOURCE_RIGHT_TRUE = 'source-right-true',
  SOURCE_RIGHT_FALSE = 'source-right-false',
  SOURCE_BOTTOM_TRUE = 'source-bottom-true',
  SOURCE_BOTTOM_FALSE = 'source-bottom-false',
}
